import { useContext } from 'react'
import { useQuery, useMutation, useQueryClient } from 'react-query'
import { apiGet, apiDelete } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

// List monitoring exclusions for the current municipality. Accepts an
// optional `section_id` filter.
export function useMonitoringExclusions({ params = {}, options = {} } = {}) {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)
  const mergedParams = { ...params }
  const queryKey = ['monitoring-exclusions', municipality_id, mergedParams]

  return useQuery(
    queryKey,
    () =>
      apiGet({
        url: `municipalities/${municipality_id}/monitoring_exclusions`,
        token,
        params: mergedParams
      }),
    { ...options }
  )
}

// Delete an exclusion. Invalidates the monitoring query set so any
// previously-hidden transactions reappear on next fetch.
export function useDeleteMonitoringExclusion({ options = {} } = {}) {
  const token = useContext(AuthContext)
  const queryClient = useQueryClient()

  return useMutation(
    async ({ exclusionId }) =>
      apiDelete({ url: `monitoring_exclusions/${exclusionId}`, token }),
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(['analytics-monitoring-transactions'])
        queryClient.invalidateQueries(['analytics-monitoring'])
        queryClient.invalidateQueries(['monitoring-high-risk-transactions'])
        queryClient.invalidateQueries(['monitoring-exclusions'])
        if (options.onSuccess) options.onSuccess(data, variables, context)
      }
    }
  )
}
